// extracted by mini-css-extract-plugin
module.exports = {"drag_over":"DataTransmat_drag_over__3XVzh","drag_active":"DataTransmat_drag_active__2nwCM"};